/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const updateMyVoicePreferencesBodySpeechSpeedMin = 0.25;
export const updateMyVoicePreferencesBodySpeechSpeedMax = 1.5;

export const UpdateMyVoicePreferencesBody = zod.object({
  speechSpeed: zod
    .number()
    .min(updateMyVoicePreferencesBodySpeechSpeedMin)
    .max(updateMyVoicePreferencesBodySpeechSpeedMax)
    .optional()
    .describe(
      'How fast the realtime voice agent speaks: a multiplier from 0.25 to 1.5, where 1.0 is normal.',
    ),
});

export type UpdateMyVoicePreferencesBody = zod.input<typeof UpdateMyVoicePreferencesBody>;
export type UpdateMyVoicePreferencesBodyOutput = zod.output<typeof UpdateMyVoicePreferencesBody>;
